import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { BackAwareDialog } from 'shared/components/dialogs/backAwareDialog';
import { SlideUpTransition } from '../react-elements/SlideUpTransition';
import { MobileDialogAppBar } from './settings/mobile-app-bar';
/**
 * @function
 * Полноэкранный диалог
 * @param props
 * @return ReactElement
 */
export const FullScreenDialog = memo(function FullScreenDialog(props) {
    const { open, onClose, children, title, toolbar, ...rest } = props;
    return (_jsxs(BackAwareDialog, { fullScreen: true, disableEnforceFocus: true, TransitionComponent: SlideUpTransition, open: open, onClose: onClose, ...rest, children: [_jsx(MobileDialogAppBar, { position: "static", active_tab_title: null, active_tab_id: null, default_tab_title: title, onClose: onClose, toolbar: toolbar }), children] }));
});
